import React from 'react';
import { View, Text, ScrollView, ActivityIndicator, Image, TextInput, CheckBox, FlatList } from 'react-native';
import { Button } from 'react-native-elements';
import screen from '../screen';
import Icon from 'react-native-vector-icons/FontAwesome';
import Lib from '../Lib';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'modal-enhanced-react-native-web';
import log from 'loglevel';
import evmLib from '../evmLib';
import daoLib from '../daoLib';

const vp = screen.vp;
const vps = screen.vps;
const spc2 = <View style={{ width: vps(2), height: vps(2) }} />;
const spc1 = <View style={{ width: vps(1), height: vps(1) }} />;

function to4dec(amount) {
  return (Math.round(Number(amount) * 10000) / 10000);
}

class DAO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ts: 0,
      imageTs: 1
    };
  }

  async componentDidMount() {
    // this.interval = setInterval(() => {
    //   this.setState({ ts: moment().unix() });
    // }, 1000);
    await this.refreshData();
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
  }

  async refreshData() {
    const nftId = this.props.selectedNFT;
    const voteData = await evmLib.voteData(nftId);
    this.setState({ voteData });
  }

  onFileChange(event) {
    log.debug(event.target);
    this.setState({ selectedFile: event.target.files[0] });
  };

  async uploadImage() {
    this.setState({ modalVisible: true, modalResult: null });
    const selectedFile = this.state.selectedFile;
    const nftId = this.props.selectedNFT;
    const ud = this.props.userData;
    const msg = 'Set image for NFT #' + nftId;

    const signature = await evmLib.getSignature(msg);
    const address = ud ? ud.userAddress : false;
    try {
      await daoLib.setNFTImage(selectedFile, nftId, address, signature);
      this.setState({ modalResult: 'success', imageTs: moment().unix() });
    } catch (err) {
      console.error(err);
      this.setState({ modalResult: 'fail' });
    }
  }

  async voteChoice(choiceId) {
    const nftId = this.props.selectedNFT;
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.voteChoice(choiceId, nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  renderModalTx() {
    let indicator = <ActivityIndicator color='gray' size='large' />;
    let msg = 'PROCESSING TX';
    let btnClose = <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalTxVisible: false })} />;
    if (this.state.txHash) {
      msg = 'PROCESS TX DONE';
      const txHash = this.state.txHash;
      indicator = <Button type="outline" title='OPEN ON EXPLORER' onPress={() => Lib.openUrl(evmLib.EURL + '/tx/' + txHash)} />
    } else if (this.state.txError) {
      msg = 'PROCESS TX FAIL';
      indicator = <Text style={{ textAlign: 'center', color: 'red' }}>{this.state.txError}</Text>
    } else {
      btnClose = null;
    }

    return (
      <Modal
        isVisible={this.state.modalTxVisible}
        onBackdropPress={() => this.setState({ modalTxVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 2 * vp, width: 300 }}>
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
              <Text> </Text>
              <Text style={{ textAlign: 'center' }}>{msg}</Text>
              <Text> </Text>
            </View>
            <View>
              {indicator}
              <View style={{ height: vp }} />
              {btnClose}
            </View>
          </View>
        </View>
      </Modal>
    );
  }

  renderModal() {
    let msg = 'SET NFT IMAGE';
    let btnClose;

    if (this.state.modalResult === 'success') {
      msg = 'SET NFT IMAGE DONE';
      btnClose = <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalVisible: false })} />;
    } else if (this.state.modalResult === 'fail') {
      msg = 'SET NFT IMAGE FAIL';
      btnClose = <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalVisible: false })} />;
    } else {
      btnClose = <ActivityIndicator color='gray' size='large' />;
    }

    return (
      <Modal
        isVisible={this.state.modalVisible}
        onBackdropPress={() => this.setState({ modalVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 2 * vp, width: 300 }}>
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
              <Text> </Text>
              <Text style={{ textAlign: 'center' }}>{msg}</Text>
              <Text> </Text>
              {btnClose}
            </View>
          </View>
        </View>
      </Modal>
    );
  }


  render() {
    let enableSetImg = false;
    let enableOpenExpl = false;
    let nftUrl;

    const nd = this.props.nftData;
    let imgWidth = this.state.nftImgWidth ? this.state.nftImgWidth : 0;

    const nftId = this.props.selectedNFT;
    let nftImg = (
      <View onLayout={e => {
        const w = e.nativeEvent.layout.width;
        this.setState({ nftImgWidth: w });
      }} style={{ backgroundColor: 'dimgray', alignItems: 'center', justifyContent: 'center', height: imgWidth }} >
        <Text style={{ textAlign: 'center', color: 'white' }}>You dont have cult NFT</Text>
      </View>
    );


    if (nftId > 0 && imgWidth > 0) {
      enableOpenExpl = true;
      enableSetImg = this.state.selectedFile ? true : false;
      nftUrl = 'https://evm.confluxscan.io/nft/0xf6d767ed934e7b2cbb000d65c1b7fb715f16d74c/' + nftId;
      const url = daoLib.getNFTURL(nftId) + '&ts=' + this.state.imageTs;
      nftImg = (
        <Image
          style={{ width: imgWidth, height: imgWidth }}
          source={{ uri: url }}
        />
      );
    }

    return (
      <View style={{ flex: 1, flexDirection: 'row', backgroundColor: 'white', maxWidth: vps(100), padding: vps(2), borderWidth: 0 }}>
        {this.renderModal()}
        {this.renderModalTx()}
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1, borderWidth: 1, borderColor: 'gainsboro', padding: vps(2) }}>
            {nftImg}
            <Text> </Text>
            <input type="file" accept="image/png, image/jpeg" onChange={e => this.onFileChange(e)} />
            <Text> </Text>
            <Button disabled={!enableSetImg} title='Set NFT Image' onPress={() => this.uploadImage()} />
            <View style={{ height: vps(1) }} />
            <Button disabled={!enableOpenExpl} type='outline' title='Open on Explorer' onPress={() => Lib.openUrl(nftUrl)} />
          </View>
        </View>
        {/* 
        {spc2}
        <View style={{ flex: 1 }}>
          {this.renderVotePanel()}
        </View> 
        */}
      </View>
    );
  }

  renderVotePanel() {
    let mayVote = false;
    const vd = this.state.voteData;
    if (vd && vd.mayVote) mayVote = true;
    const data = {
      title: 'DAO Vote #1: LP Vault Boost',
      opts: [
        { label: 'APR x1', cb: () => this.voteChoice(1) },
        { label: 'APR x10', cb: () => this.voteChoice(2) },
        { label: 'APR x50', cb: () => this.voteChoice(3) }
      ]
    }

    if (vd) {
      const bestChoice = vd.bestChoice;
      if (bestChoice > 0) data.opts[bestChoice - 1].winner = true;
      data.opts[0].voters = vd.choices[0].voters;
      data.opts[1].voters = vd.choices[1].voters;
      data.opts[2].voters = vd.choices[2].voters;
    }

    log.debug(data);

    return (
      <View style={{ flex: 1, borderColor: 'gainsboro', borderWidth: 1 }}>
        <View style={{ borderColor: 'gainsboro', borderBottomWidth: 1, padding: vps(2), backgroundColor: 'black' }}>
          <Text style={{ textAlign: 'center', color: 'white' }}>{data.title.toUpperCase()}</Text>
        </View>
        {
          data.opts.map((item, i) => {
            let winnerLabel = null;
            if (item.winner) winnerLabel = <Text style={{ color: 'green' }}>[MOST VOTES]</Text>;
            let voters = (<View style={{ height: 32, justifyContent: 'center' }}>
              <Text style={{ color: 'gray' }}>NO VOTE</Text>
            </View>
            );
            if (item.voters && item.voters.length > 0) {
              voters = (
                <ScrollView horizontal>
                  <View style={{ flexDirection: 'row' }}>
                    {
                      item.voters.map((item2, i) => {
                        const url = daoLib.getNFTURL(item2) + '&thumb=1';
                        return (
                          <View style={{ paddingRight: 5 }}>
                            <Image
                              style={{ width: 32, height: 32 }}
                              source={{ uri: url }}
                            />
                          </View>
                        );
                      })
                    }
                  </View>
                </ScrollView>
              );
            }
            return (
              <View style={{ borderColor: 'gainsboro', borderBottomWidth: 1 }}>
                <View style={{ flexDirection: 'row', padding: vps(2) }}>
                  <View style={{ flex: 1, justifyContent: 'center' }}>
                    <Text style={{ textAlign: 'left' }}>{item.label} {winnerLabel}</Text>
                  </View>
                  <Button disabled={!mayVote} title='Vote' onPress={() => item.cb()} />
                </View>
                <View style={{ flexDirection: 'row', paddingHorizontal: vps(2), paddingVertical: vps(1), borderColor: 'gainsboro', borderTopWidth: 1 }}>
                  {voters}
                </View>
              </View>
            );
          })
        }
        <View style={{ padding: vps(2) }}>
          <Button type='outline' title='Discussion' onPress={() => Lib.openUrl('https://t.me/dragoncultxyz')} />
        </View>
      </View>
    );
  }

}

export default DAO;
